import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const PlusIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <g>
            <path
               d="M10.7063 24C10.4089 24 10.1561 23.8951 9.94795 23.6854C9.73978 23.4757 9.63569 23.221 9.63569 22.9213V14.1573H1.07063C0.773234 14.1573 0.520446 14.0524 0.312268 13.8427C0.104089 13.633 0 13.3783 0 13.0787L0 10.6966C0 10.367 0.104089 10.1124 0.312268 9.93258C0.520446 9.72285 0.773234 9.61798 1.07063 9.61798H9.63569V1.07865C9.63569 0.779024 9.73978 0.524345 9.94795 0.314608C10.1561 0.104869 10.4089 0 10.7063 0L13.2937 0C13.6208 0 13.8736 0.104869 14.052 0.314608C14.2602 0.524345 14.3643 0.779024 14.3643 1.07865V9.61798H22.9294C23.2268 9.61798 23.4796 9.72285 23.6877 9.93258C23.8959 10.1124 24 10.367 24 10.6966V13.0787C24 13.3783 23.8959 13.633 23.6877 13.8427C23.4796 14.0524 23.2268 14.1573 22.9294 14.1573H14.3643V22.9213C14.3643 23.221 14.2602 23.4757 14.052 23.6854C13.8736 23.8951 13.6208 24 13.2937 24H10.7063Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_10722_38670">
               <rect fill="currentColor" />
            </clipPath>
         </defs>
      </svg>
   )
}

export default PlusIcon
